//UCEPRODENG-746, 776 Phone Number valid format
import PhoneUtil from 'gw-portals-util-angular/PhoneUtil';

export default [
    'LocaleService',
    LocaleService =>( number, country) => PhoneUtil(LocaleService).prettyPrintPSA(number, country)
];